import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { axiosInstance } from '../../api';
import { endpoints } from '../../api/endpoints';
import notify from '../../utils/notify';

const storedToken = localStorage.getItem('token');

const initialState = {
    isLoading: false,
    userLoggedIn: storedToken?.length ? true : false,
    token: storedToken?.length ? storedToken : null,
    errorMessage: null,
};

export const login = createAsyncThunk('login', (data, thunkAPI) => {
    const response = axiosInstance
        .post(endpoints.signin, data)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return thunkAPI.rejectWithValue(error);
        });
    return response;
});

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        logout: (state, action) => {
            state.token = null;
            state.userLoggedIn = false;
            localStorage.removeItem('token');
        },
    },
    extraReducers: (builder) => {
        builder.addCase(login.pending, (state, action) => {
            state.errorMessage = null;
            state.isLoading = true;
        });
        builder.addCase(login.fulfilled, (state, action) => {
            const token = action.payload.token;
            state.errorMessage = null;
            state.isLoading = false;
            state.userLoggedIn = true;
            state.token = token;
            localStorage.setItem('token', token);
        });
        builder.addCase(login.rejected, (state, action) => {
            state.isLoading = false;
            notify(action.payload.response.data.Message);
        });
    },
});

export const { logout } = authSlice.actions;

export default authSlice.reducer;
